"use strict";
const assert = require('assert').strict;
const csvToList = require('./csvToList');
const resolveMatcher = (comparisonString, items, matcher) => items.some(matcher(comparisonString));
module.exports = (rawComparisonString, rawItemString, matcher) => {
    assert(typeof rawComparisonString === 'string');
    assert(typeof rawItemString === 'string');
    assert(typeof matcher === 'function');
    assert(typeof matcher('') === 'function');
    assert(typeof matcher('')('') === 'boolean');
    const items = csvToList(rawItemString);
    return resolveMatcher(rawComparisonString, items, matcher);
};
//# sourceMappingURL=evaluateMatcher.js.map